// src/Views/Speaking.js
import React, { useEffect, useRef } from 'react';
import './Speaking.css';
import trophyImage from '../assets/images/2024publicspeakingphotos/11.png';

const Speaking = () => {
  const heroRef = useRef(null);

  useEffect(() => {
    const scrollToHero = () => {
      heroRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    // Scroll once after layout settles, then again after the page
    // fully loads (so late-loading images like the trophy don't shift it)
    const timer = setTimeout(scrollToHero, 150);
    window.addEventListener('load', scrollToHero);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('load', scrollToHero);
    };
  }, []);

  return (
    <div className="speaking-page">

      {/* Title Section */}
      <section className="speaking-title" ref={heroRef}>
        <h1>The 3rd Hong Kong Clean Air Public Speaking Contest</h1>
      </section>

      {/* About Card */}
      <section className="speaking-about">
        <div className="about-card">
          <div className="about-content">
            <h2>About</h2>
            <p>
              The Contest encourages all passionate students to voice out their passions of making the world a better place,
              and to continue promoting and advocating for clean air in Hong Kong.
            </p>
            <p>
              Last year, with attendees from over 28 schools, we awarded prizes of up to $4,000 to the winners of the competition.
            </p>
            <div className="about-buttons">
              <a
                href="https://docs.google.com/forms/d/e/1FAIpQLSc0RazKJo8h-gcxtItMQTih6FLlfIHxHYMW-o5JIuZWayrMmQ/viewform?usp=header"
                target="_blank"
                rel="noopener noreferrer"
                className="about-button apply-button"
              >
                Apply Now
              </a>
              <a
                href="https://docs.google.com/document/d/1VvCESMKZvaBuXiKeuXvchnHLtaC1KfdC6um8_1xZ1I4/edit?tab=t.0"
                target="_blank"
                rel="noopener noreferrer"
                className="about-button guidelines-button"
              >
                Guidelines
              </a>
            </div>
          </div>
          <div className="about-image">
            <img src={trophyImage} alt="Public Speaking Trophy" />
          </div>
        </div>
      </section>

      {/* Event Details */}
      <div className="details-grid">
        <div className="detail-item">
          <h3>Date</h3>
          <p>Nov 29, 2025 (Sat)</p>
        </div>
        <div className="detail-item">
          <h3>Time</h3>
          <p>9:00 AM (Junior Category) <br /> 12:30pm (Senior Catergory) </p>
        </div>
        <div className="detail-item">
          <h3>Location</h3>
          <p> Clean Air Network Event Space<br />16F, Chun Wo Commercial Centre, 23-29 Wing Wo Street, Sheung Wan</p>
        </div>
        <div className="detail-item">
          <h3>Fee</h3>
          <p>Free of charge</p>
        </div>
        <div className="detail-item">
          <h3>Awards</h3>
          <p>Champion: Cash Prize $1000<br /> 1st Runner-up: Cash Prize $500 <br /> 2nd Runner-up: Cash Prize $200</p>
        </div>
        <div className="detail-item">
          <h3>How to apply</h3>
          <p>Apply via this <a href="https://docs.google.com/forms/d/e/1FAIpQLSc0RazKJo8h-gcxtItMQTih6FLlfIHxHYMW-o5JIuZWayrMmQ/viewform?usp=header" target="_blank" rel="noopener noreferrer">form</a> by Nov 9 2025</p>
        </div>
      </div>

      {/* About CASC Section */}
      <div className="about-casc">
        <h2>About Clean Air Student Council</h2>
        <p>
          Established in 2019, the Clean Air Student Council is the youth branch of the Clean Air Network,
          representing students from over 10 schools in Hong Kong. To date, CASC has empowered more than
          1000 students and stands as the largest student clean air advocacy group in the city.
        </p>
        <a
          href="https://byeigostudy.wixsite.com/casc/blog/categories/clean-air-public-speaking-contest"
          target="_blank"
          rel="noopener noreferrer"
          className="casc-link"
        >
          Learn more about past Hong Kong Clean Air Public Speaking Contests &gt;
        </a>
      </div>
    </div>
  );
};

export default Speaking;
